import ErrorResponseObject from '../interfaces/errorResponseObject';

let showErrorModalCallback: ((code: number) => void) | null = null;

export const registerErrorModalCallback = (callback: (code: number) => void) => {
  showErrorModalCallback = callback;
};

export const triggerErrorModal = (error: ErrorResponseObject) => {
  const code: number = error?.response?.status ?? 404;
  if (showErrorModalCallback) {
    showErrorModalCallback(code);
  }
};